module.exports = "/_next/static/images/33f1016fe17194a13c2ae687cece3a42-icon-app-new.svg.webp";